(function (){
    'use strict';

    angular
        .module('auth')
        .controller('LoginController', LoginController)
    LoginController.$inject = ['AuthService','UserService','$state','$rootScope','jwtHelper','AclService'];

    function LoginController(AuthService, UserService, $state, $rootScope, jwtHelper, AclService) {
        var vm = this;

        vm.email = '';
        vm.password = '';

        vm.processing = '';
        vm.submit = submit;

        vm.message = null;

        function activate () {

        }

        function submit () {
            vm.processing = true;

            AuthService.login(vm.email, vm.password)
            .then( function () {
                return AuthService.getCurrentUser();
            })
            .then( function (user) {
                $state.go('root.dashboard');
            }).catch(function (err) {
                vm.message = 'Invalid Email / Password';
            }).finally ( function () {
                vm.processing = false;
            });
        }
        activate();
    }
})();